export default __webpack_public_path__ + "assets/images/c7422fabe6dd1773ebf38bd7ad2c26ec.jpg";